<template>
    <div class="col-md-12">
        <div class="panel panel-visible" id="spy2">

            <div class="panel-heading">
                <div class="panel-title hidden-xs">
                    <span class="glyphicon glyphicon-tasks"></span>SMS</div>
            </div>
            <div class="panel-body pn">
                <grid-view
                        :loader="loader"
                        store-name="sms-list"
                        defaultSort="-id"
                        :extraFields="['client', 'creator']"
                >
                    <template #header>
                        <th>ID</th>
                        <th>Клиент</th>
                        <th>Телефон</th>
                        <th>Текст</th>
                        <th>ID провайдера</th>
                        <th>Статус отправки</th>
                        <th>Дата отправки</th>
                        <th>Автор</th>
                    </template>
                    <template v-slot:row="{ row }">
                        <td>{{row.id}}</td>
                        <td>
                            <router-link v-if="row.client" :to="{name: 'clients-edit', params: {id: row.client_id}}">
                                {{row.client.full_name}}
                            </router-link>
                            <span v-else>---</span>
                        </td>
                        <td>{{row.phone}}</td>
                        <td class="fs11">
                            {{row.content}}
                        </td>
                        <td>{{row.outer_id}}</td>
                        <td class="fs11">
                            <span v-if="row.status === 1" class="badge badge-success fs11">Доставлено</span>
                            <span v-else class="badge badge-danger fs11">Отклонено</span>
                        </td>
                        <td class="fs11">{{row.created_at | dateFormatTimestamp('dd.mm.yyyy HH:MM')}}</td>
                        <td>{{row.creator ? row.creator.fullName : ''}}</td>
                    </template>
                </grid-view>
            </div>
        </div>
    </div>
</template>

<script>
    import Sms from "../../models/v2/Sms";

    export default {
        components: {
            gridView: () => import('../data/table/GridView'),
        },
        data() {
            return {
                directions: [],
                loader: Sms.getList,
            };
        },
        methods: {
        },
        metaInfo() {
            return {
                title: 'SMS - список',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
